import { MatchResultPlayerStatus } from '@okletsplay/core';

export const MATCH_RESULT_PLAYER_STATUS_TEXT = {
  [MatchResultPlayerStatus.Win]: 'winner',
  [MatchResultPlayerStatus.Forfeit]: 'forfeit',
  [MatchResultPlayerStatus.Tied]: 'tied',
  [MatchResultPlayerStatus.Lose]: '',
};
